import { Database } from "../interface";
import { api } from "../api";
import { store } from "../store";
import { lang } from "../lang";
import * as HelperSrc from "../HelperSrc";

async function getDatabases(): Promise<Database[] | null> {
    if (api.clientApi) {
        return api.clientApi.clientList().then((response) => {
            if (response instanceof Error || (response.message && response.message.error)) {
                if (response instanceof Error) {
                    HelperSrc.writeLog("error", response);
                } else {
                    store.doNotice(lang[response.message.error]);
                }
                return null;
            }
            return response as unknown as Database[];
        });
    } else {
        return null;
    }
}

export { getDatabases };
